import React from 'react'
import { Col, Container, Form, Row, Button } from "react-bootstrap";
import {
    FaTwitter,
    FaFacebookF,
    FaLinkedin,
    FaGithub,
} from "react-icons/fa";
import {HiOutlineMail,HiPhone,HiLocationMarker} from "react-icons/hi";
import './Contact.css'
const Contact = () => {
  return (
    <div className='contact'id='footer' >
        <Container>
<a className="logo" href="index.html">
                                MA
                            </a>
            <Row>
<Col className='form'>  
                            <h2> Have a question or want to work together?</h2>{" "}
                            <Form>
                                <Form.Group
                                    className="mb-4"
                                    controlId="exampleForm.ControlInput1"
                                >
                                    <Form.Control
                                    size="lg"
                                        type="text"
                                        placeholder="Your Name"
                                    />
                                </Form.Group>
                                <Form.Group
                                    className="mb-4"
                                    controlId="exampleForm.ControlInput1"
                                >
                                    <Form.Control
                                    size="lg"
                                        type="email"
                                        placeholder="Your Email"
                                    />
                                </Form.Group>
                                <Form.Group
                                    className="mb-4"
                                    controlId="exampleForm.ControlInput1"
                                >
                                    <Form.Control
                                    size="lg"
                                        type="text"
                                        placeholder="Your Subject"
                                    />
                                </Form.Group>
                                <Form.Group
                                    className="mb-4"
                                    controlId="exampleForm.ControlTextarea1"
                                >
                                    <Form.Control
                                    size="lg"
                                        as="textarea"
                                        rows={5}
                                        placeholder="You Message"
                                    />
                                </Form.Group>
                                <Button
                                variant="dark"
                                    as="input"
                                    type="submit"
                                    value="Send Message"
                                    className="submit-btn"
                                />{" "}
                            </Form>
                        </Col>
<Col className='info'>
    
<h2> Contact Info</h2>
<p>I'm Mahmoud Ashraf
I'm a Front-end web developer Bachelor’s degree at Computer and Information Sciences, I am always seeking to enhance my technical to increase my knowledge and my experts</p>
<div className='info-details'>
         

            <div className="contact-info">
             <HiPhone className='icons'/>
                 <div className="info-details">
                <h4>Phone</h4>
                <span>+02 01095691698</span>     
            </div>
            <div className="contact-info">
              <HiLocationMarker className='icons'/>
              <div className="info-details">
                <h4>Address</h4>
                <span>  Ein Shams Street<br />Cairo, Egypt</span>
                </div>
                </div>
                <div className="contact-info">
              <HiOutlineMail className='icons'/>
              <div className="info-details">
                <h4>Email</h4>
                <span>mahmoudyaqout163<br />@gmail.com</span>
              </div>
            </div>
</div>
</div>
<h4 className='social-text'>Visite My Social Profile & Get Connected</h4>
<Row>
                            <div
                                className="social-links "
                            >
                                <a
                                    href="https://twitter.com/Ashrof_74"
                                    className="twitter"
                                    rel="noopener noreferrer"
                                    target="_blank"
                                >
                                    <FaTwitter />
                                </a>
                                <a
                                    href="https://www.facebook.com/Mahmoud.Ashraf.740/"
                                    className="facebook"
                                    rel="noopener noreferrer"
                                    target="_blank"
                                >
                                    <FaFacebookF />
                                </a>

                                <a
                                    href="https://www.linkedin.com/in/mahmoud-ashraf-66a070174/"
                                    className="linkedin"
                                    rel="noopener noreferrer"
                                    target="_blank"
                                >
                                    <FaLinkedin />
                                </a>{" "}
                                <a
                                    href="https://github.com/mahmoudashraf74?tab=repositories"
                                    className="github"
                                    rel="noopener noreferrer"
                                    target="_blank"
                                >
                                    <FaGithub />
                                </a>
                            </div>
                        </Row>
</Col>



            </Row>
        </Container>
    </div>
  )
}

export default Contact